import { TitoloEsecutivo } from '../../../models/titolo-esecutivo';

export class TitoloEsecutivoAdapter {

  titoloEsecutivo: TitoloEsecutivo = new TitoloEsecutivo();

  constructor(titoloEsecutivo: TitoloEsecutivo) {
    this.titoloEsecutivo.anno = titoloEsecutivo.anno ? titoloEsecutivo.anno : null;
    this.titoloEsecutivo.dataIscrizione = titoloEsecutivo.dataIscrizione ? titoloEsecutivo.dataIscrizione: null;
    this.titoloEsecutivo.descrizione = titoloEsecutivo.descrizione ? titoloEsecutivo.descrizione : null;
    this.titoloEsecutivo.documenti = titoloEsecutivo.documenti ? titoloEsecutivo.documenti : null;
    this.titoloEsecutivo.id = titoloEsecutivo.id ? titoloEsecutivo.id : null;
    this.titoloEsecutivo.numero = titoloEsecutivo.numero? titoloEsecutivo.numero : null;
    this.titoloEsecutivo.sottoTipoTitoloEsecutivo = titoloEsecutivo.sottoTipoTitoloEsecutivo ? JSON.parse(JSON.stringify(titoloEsecutivo.sottoTipoTitoloEsecutivo)) : null;
    this.titoloEsecutivo.tipoTitoloEsecutivo = titoloEsecutivo.tipoTitoloEsecutivo ? JSON.parse(JSON.stringify(titoloEsecutivo.tipoTitoloEsecutivo)) : null;
    this.titoloEsecutivo.valore = titoloEsecutivo.valore ? titoloEsecutivo.valore : null;
    this.titoloEsecutivo.note = titoloEsecutivo.note ? titoloEsecutivo.note : null;
  }
}
